// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"5a9f12f7","551":"d1f80929","851":"eb2da93c"}[chunkId] + ".chunk.js";
};